module.exports = __webpack_public_path__ + "media/images/noshis/butsunoshimihon-ccb4c91198c23370c6b5f75cd6bec528.jpg";